export default __webpack_public_path__ + "static/bottle-748afe6b8fc9aa87cc2905adbf6a9ca9.png";